import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { SearchApprenticeParams, SearchApprenticeResponse } from '@models/apprentice/apprentice';
import { ContactTrainingCenter } from '@models/apprentice/contact-training-center';
import { LBARomesLabelsResponse, RomesLabels } from '@models/apprentice/romelabels';
import { UnsollicitedApplication } from '@models/apprentice/unsollicited-application';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApprenticeWebService {
  constructor(private readonly http: HttpClient) {}

  searchApprentice(payload: SearchApprenticeParams): Observable<SearchApprenticeResponse> {
    let params = new HttpParams();

    Object.entries(payload).forEach(([key, value]) => {
      params = params.set(key, value.toString());
    });

    return this.http.get<SearchApprenticeResponse>(`${environment.api.job_api_v2}/v1/apprenticeship`, {
      params,
    });
  }

  getRomeLabels(query: string): Observable<RomesLabels[]> {
    const params = new HttpParams().set('title', query);

    return this.http
      .get<LBARomesLabelsResponse>(`${environment.api.lba}/api/romelabels`, {
        params,
      })
      .pipe(map((res) => res.labelsAndRomes.map((item) => ({ label: item.label, romes: item.romes }))));
  }

  contactTrainingCenter({ formationId, ...candidateInfos }: ContactTrainingCenter): Observable<unknown> {
    const apiEndpoint = `${environment.api.job_api_v2}/v1/apprenticeship/formation/${formationId}/contact`;
    return this.http.post<unknown>(apiEndpoint, candidateInfos);
  }

  unsolicitedApplyToCompany({ companyId, ...application }: UnsollicitedApplication): Observable<unknown> {
    const apiEndpoint = `${environment.api.job_api_v2}/v1/apprenticeship/company/${companyId}/contact`;
    return this.http.post<unknown>(apiEndpoint, application);
  }
}
